export default __webpack_public_path__ + "static/media/img.9a1c696b.png";